<template>
  <section class="content close-date-picker">
    <div
      class="modal fade model_modify_wrp"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="width: 50%">
        <div class="modal-content">
          <div class="modal-header">
            <h2>Export CSV</h2>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <csvExport :data="filterDateData" :type="type"></csvExport>
          </div>
          <!-- <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div> -->
        </div>
      </div>
    </div>

    <div>
      <div class="box-body">
        <!-- <date-picker @change="startDate()" id="startDate" v-model="date.startDate" lang="en" name="startDate" required input-class="form-control" width="100%" valueType="format" :format="'YYYY-MM-DD'"></date-picker>
          <date-picker @change="endDate()" :not-before="date.startDate"  id="endDate" v-model="date.endDate"  lang="en" name="endDate" required input-class="form-control" width="100%" valueType="format" :format="'YYYY-MM-DD'"></date-picker>-->

        <div :class="addButtonClass">
          <div class="datedrop_boxs_wrp">
            <span v-if="date.startDate"></span>
            <span v-else
              ><button
                type="button"
                class="btn gradientbt"
                v-on:click="show = !show"
              >
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 122.88 119.97"
                  style="enable-background:new 0 0 122.88 119.97"
                  xml:space="preserve"
                >
                  <g>
                    <path
                      d="M69.76,4.06c0-2.23,2.2-4.06,4.95-4.06s4.95,1.81,4.95,4.06V21.8c0,2.23-2.2,4.06-4.95,4.06s-4.95-1.81-4.95-4.06V4.06 L69.76,4.06L69.76,4.06z M14.37,78.05h11.34c0.72,0,1.31,0.59,1.31,1.31v8.38c0,0.72-0.59,1.31-1.31,1.31H14.37 c-0.72,0-1.31-0.59-1.31-1.31v-8.38C13.06,78.63,13.65,78.05,14.37,78.05L14.37,78.05z M57.79,54.17h11.34 c0.35,0,0.66,0.14,0.9,0.36c-4.45,2.78-8.31,6.4-11.37,10.65h-0.87c-0.72,0-1.31-0.59-1.31-1.31v-8.38 C56.48,54.76,57.07,54.17,57.79,54.17L57.79,54.17z M36.08,54.17h11.34c0.72,0,1.31,0.59,1.31,1.31v8.38 c0,0.72-0.59,1.31-1.31,1.31H36.08c-0.72,0-1.31-0.59-1.31-1.31v-8.38C34.77,54.76,35.36,54.17,36.08,54.17L36.08,54.17z M14.37,54.17h11.34c0.72,0,1.31,0.59,1.31,1.31v8.38c0,0.72-0.59,1.31-1.31,1.31H14.37c-0.72,0-1.31-0.59-1.31-1.31v-8.38 C13.06,54.76,13.65,54.17,14.37,54.17L14.37,54.17z M36.08,78.05h11.34c0.72,0,1.31,0.59,1.31,1.31v8.38 c0,0.72-0.59,1.31-1.31,1.31H36.08c-0.72,0-1.31-0.59-1.31-1.31v-8.38C34.77,78.63,35.36,78.05,36.08,78.05L36.08,78.05z M103.49,59.54c11.71,4.85,19.39,16.28,19.39,29.02c0,8.67-3.52,16.53-9.2,22.21c-5.68,5.68-13.53,9.2-22.21,9.2 c-8.67,0-16.52-3.52-22.21-9.2c-5.68-5.69-9.2-13.54-9.2-22.21c0-12.64,7.86-24.43,19.55-29.23 C86.86,56.37,96.29,56.55,103.49,59.54L103.49,59.54L103.49,59.54z M86.64,87.72c0.39-0.43,0.87-0.8,1.39-1.08V72.98 c0-1.39,1.13-2.52,2.52-2.52c1.39,0,2.53,1.13,2.53,2.52v13.66c0.92,0.5,1.68,1.25,2.17,2.17h9.76c1.4,0,2.52,1.13,2.52,2.52 s-1.13,2.52-2.52,2.52h-9.76c-0.9,1.68-2.66,2.82-4.7,2.82c-1.6,0-3.03-0.71-4.01-1.82C84.73,92.78,84.82,89.69,86.64,87.72 L86.64,87.72L86.64,87.72z M110.12,70.41c-13.01-13.01-34.95-9.33-42.56,7.05c-1.56,3.37-2.44,7.13-2.44,11.09 c0,7.28,2.95,13.87,7.72,18.64c4.77,4.77,11.36,7.72,18.64,7.72c7.28,0,13.87-2.96,18.64-7.72c4.77-4.77,7.72-11.36,7.72-18.64 c0-4.13-0.95-8.04-2.64-11.52C113.91,74.4,112.19,72.48,110.12,70.41L110.12,70.41L110.12,70.41z M25.33,4.06 c0-2.23,2.2-4.06,4.95-4.06c2.74,0,4.95,1.81,4.95,4.06V21.8c0,2.23-2.21,4.06-4.95,4.06c-2.74,0-4.95-1.81-4.95-4.06V4.06 L25.33,4.06L25.33,4.06z M5.45,38.79h94.21V18.37c0-0.7-0.28-1.31-0.73-1.76c-0.45-0.45-1.09-0.73-1.76-0.73h-9.03 c-1.51,0-2.74-1.23-2.74-2.74c0-1.51,1.23-2.74,2.74-2.74h9.03c2.21,0,4.2,0.89,5.65,2.34c1.45,1.45,2.34,3.44,2.34,5.65v32.43 c-1.8-0.62-3.65-1.12-5.56-1.49v-5.07h0.06H5.45v52.91c0,0.7,0.28,1.31,0.73,1.76c0.45,0.45,1.09,0.73,1.76,0.73h44.77 c0.51,1.9,1.15,3.76,1.92,5.54H7.99c-2.2,0-4.2-0.89-5.65-2.34C0.89,101.4,0,99.42,0,97.21V18.39c0-2.2,0.89-4.19,2.34-5.65 c1.45-1.45,3.44-2.34,5.65-2.34h9.64c1.51,0,2.74,1.23,2.74,2.74c0,1.51-1.23,2.74-2.74,2.74H7.99c-0.7,0-1.31,0.28-1.76,0.73 c-0.45,0.45-0.73,1.09-0.73,1.76v20.43H5.45V38.79L5.45,38.79z M43.13,15.87c-1.51,0-2.74-1.23-2.74-2.74 c0-1.51,1.23-2.74,2.74-2.74h18.39c1.51,0,2.74,1.23,2.74,2.74c0,1.51-1.23,2.74-2.74,2.74H43.13L43.13,15.87L43.13,15.87z"
                    />
                  </g>
                </svg>
                Select Start and End Dates
              </button></span
            >
            <span v-if="date.startDate">
              <div class="datemodify" v-on:click="show = true">
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 122.88 119.97"
                  style="enable-background:new 0 0 122.88 119.97"
                  xml:space="preserve"
                >
                  <g>
                    <path
                      d="M69.76,4.06c0-2.23,2.2-4.06,4.95-4.06s4.95,1.81,4.95,4.06V21.8c0,2.23-2.2,4.06-4.95,4.06s-4.95-1.81-4.95-4.06V4.06 L69.76,4.06L69.76,4.06z M14.37,78.05h11.34c0.72,0,1.31,0.59,1.31,1.31v8.38c0,0.72-0.59,1.31-1.31,1.31H14.37 c-0.72,0-1.31-0.59-1.31-1.31v-8.38C13.06,78.63,13.65,78.05,14.37,78.05L14.37,78.05z M57.79,54.17h11.34 c0.35,0,0.66,0.14,0.9,0.36c-4.45,2.78-8.31,6.4-11.37,10.65h-0.87c-0.72,0-1.31-0.59-1.31-1.31v-8.38 C56.48,54.76,57.07,54.17,57.79,54.17L57.79,54.17z M36.08,54.17h11.34c0.72,0,1.31,0.59,1.31,1.31v8.38 c0,0.72-0.59,1.31-1.31,1.31H36.08c-0.72,0-1.31-0.59-1.31-1.31v-8.38C34.77,54.76,35.36,54.17,36.08,54.17L36.08,54.17z M14.37,54.17h11.34c0.72,0,1.31,0.59,1.31,1.31v8.38c0,0.72-0.59,1.31-1.31,1.31H14.37c-0.72,0-1.31-0.59-1.31-1.31v-8.38 C13.06,54.76,13.65,54.17,14.37,54.17L14.37,54.17z M36.08,78.05h11.34c0.72,0,1.31,0.59,1.31,1.31v8.38 c0,0.72-0.59,1.31-1.31,1.31H36.08c-0.72,0-1.31-0.59-1.31-1.31v-8.38C34.77,78.63,35.36,78.05,36.08,78.05L36.08,78.05z M103.49,59.54c11.71,4.85,19.39,16.28,19.39,29.02c0,8.67-3.52,16.53-9.2,22.21c-5.68,5.68-13.53,9.2-22.21,9.2 c-8.67,0-16.52-3.52-22.21-9.2c-5.68-5.69-9.2-13.54-9.2-22.21c0-12.64,7.86-24.43,19.55-29.23 C86.86,56.37,96.29,56.55,103.49,59.54L103.49,59.54L103.49,59.54z M86.64,87.72c0.39-0.43,0.87-0.8,1.39-1.08V72.98 c0-1.39,1.13-2.52,2.52-2.52c1.39,0,2.53,1.13,2.53,2.52v13.66c0.92,0.5,1.68,1.25,2.17,2.17h9.76c1.4,0,2.52,1.13,2.52,2.52 s-1.13,2.52-2.52,2.52h-9.76c-0.9,1.68-2.66,2.82-4.7,2.82c-1.6,0-3.03-0.71-4.01-1.82C84.73,92.78,84.82,89.69,86.64,87.72 L86.64,87.72L86.64,87.72z M110.12,70.41c-13.01-13.01-34.95-9.33-42.56,7.05c-1.56,3.37-2.44,7.13-2.44,11.09 c0,7.28,2.95,13.87,7.72,18.64c4.77,4.77,11.36,7.72,18.64,7.72c7.28,0,13.87-2.96,18.64-7.72c4.77-4.77,7.72-11.36,7.72-18.64 c0-4.13-0.95-8.04-2.64-11.52C113.91,74.4,112.19,72.48,110.12,70.41L110.12,70.41L110.12,70.41z M25.33,4.06 c0-2.23,2.2-4.06,4.95-4.06c2.74,0,4.95,1.81,4.95,4.06V21.8c0,2.23-2.21,4.06-4.95,4.06c-2.74,0-4.95-1.81-4.95-4.06V4.06 L25.33,4.06L25.33,4.06z M5.45,38.79h94.21V18.37c0-0.7-0.28-1.31-0.73-1.76c-0.45-0.45-1.09-0.73-1.76-0.73h-9.03 c-1.51,0-2.74-1.23-2.74-2.74c0-1.51,1.23-2.74,2.74-2.74h9.03c2.21,0,4.2,0.89,5.65,2.34c1.45,1.45,2.34,3.44,2.34,5.65v32.43 c-1.8-0.62-3.65-1.12-5.56-1.49v-5.07h0.06H5.45v52.91c0,0.7,0.28,1.31,0.73,1.76c0.45,0.45,1.09,0.73,1.76,0.73h44.77 c0.51,1.9,1.15,3.76,1.92,5.54H7.99c-2.2,0-4.2-0.89-5.65-2.34C0.89,101.4,0,99.42,0,97.21V18.39c0-2.2,0.89-4.19,2.34-5.65 c1.45-1.45,3.44-2.34,5.65-2.34h9.64c1.51,0,2.74,1.23,2.74,2.74c0,1.51-1.23,2.74-2.74,2.74H7.99c-0.7,0-1.31,0.28-1.76,0.73 c-0.45,0.45-0.73,1.09-0.73,1.76v20.43H5.45V38.79L5.45,38.79z M43.13,15.87c-1.51,0-2.74-1.23-2.74-2.74 c0-1.51,1.23-2.74,2.74-2.74h18.39c1.51,0,2.74,1.23,2.74,2.74c0,1.51-1.23,2.74-2.74,2.74H43.13L43.13,15.87L43.13,15.87z"
                    />
                  </g>
                </svg>
                <input v-model="date.startDate" /> to
                <input v-model="date.endDate" />
              </div>
            </span>
            <span v-else> </span>

            <div v-if="show" class="datedrop_boxs">
              <date-picker
                @change="startDate()"
                id="startDate"
                v-model="date.startDate"
                lang="en"
                name="startDate"
                required
                input-class="form-control"
                width="100%"
                valueType="format"
                :format="'DD-MM-YYYY'"
                placeholder="Start date"
              ></date-picker>
              <date-picker
                @change="endDate()"
                :not-before="startDateIso"
                id="endDate"
                v-model="date.endDate"
                lang="en"
                name="endDate"
                required
                input-class="form-control"
                width="100%"
                valueType="format"
                :format="'DD-MM-YYYY'"
                placeholder="End date"
              ></date-picker>
            </div>
          </div>

          <button
            type="button"
            class="btn gradientbt"
            data-toggle="modal"
            data-target="#exampleModal"
            v-on:click="changestate()"
          >
            Export CSV
          </button>
          <router-link :to="{ name: 'dailywagescreate', params: { _id: '0' } }">
            <button class=" btn gradientbt">Add Daily Wages</button>
          </router-link>
          <!-- <button @click="csvExport(csvData)">Export to CSV</button> -->
        </div>

        <v-server-table
          ref="dailyWagesTable"
          url
          :limit="5"
          :columns="columns"
          :options="options"
          @loaded="onLoaded"
        >
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>

          <template slot="receipt" slot-scope="props">
            <a v-bind:href="props.row.receipt" target="_blank">View</a>
          </template>

          <template slot="action" slot-scope="props">
            <div class="active_wrp">
              <a
                class="fa fa-edit"
                role="button"
                v-on:click.stop="action(props.row)"
              ></a>

              <a
                class="fa fa-trash"
                role="button"
                v-on:click.stop="deleteDailyWagesModal(props.row)"
              ></a>
            </div>
          </template>
        </v-server-table>
      </div>
    </div>
  </section>
</template>

<script>
import {
  eventBus,
  dailyWagesService,
  exportcsvService,
  formService,
} from "../../../services";
import { USER_ROLES } from "../../../config";
import { ServerTable, Event } from "vue-tables-2";
import { mapState } from "vuex";

import store from "../../../store";
import swal from "sweetalert2";
import moment from "moment";
import csvExport from "../csvexport/csvexport.vue";
import dateFormatter from "../../utilities/dateFormate";

export default {
  name: "dailywages",
  components: {
    csvExport,
  },
  data() {
    return {
      show: false,
      disabledAfter: null,

      date: {
        startDate: "",
        endDate: "",
      },
      type: "wages",
      data: {},
      formstate: {},
      filterDateData: {},
      user1: [],
      loading: null,
      USER_ROLES: USER_ROLES,
      dailyWagesTable: null,
      page: null,
      limit: null,
      endDateIso: "",
      startDateIso: "",
      columns: [
        "cityName",
        "expense",
        "expenseDate",
        "expenseType",
        "amount",
        "firstName",
        "receipt",
        "createdAt",
        "action",
      ],

      options: {
        highlightMatches: true,
        headings: {
          cityName: "City",
          expense: "Expense",
          expenseDate: "Expense Date",
          expenseType: "Expense Type",
          amount: "Amount (INR)",
          firstName: "Created By",
          receipt: "Receipt",
          createdAt: "Created On",
          action: "Action",
        },
        templates: {
          createdAt(row, query) {
            return dateFormatter(query.createdAt);
            // return moment.utc(query.createdAt).format("DD-MM-YYYY");
          },
          expenseDate(row, query) {
            return moment.utc(query.expenseDate).format("DD-MM-YYYY");
          },
        },
        perPage: 10,
        sortable: [
          "expense",
          "expenseDate",
          "expenseType",
          "amount",
          "firstName",
          "createdAt",
        ],
        requestFunction: (request) => {
          const params = {};
          params.page = request.page;
          params.limit = request.limit;

          this.page = request.page;
          this.limit = request.limit;

          if (request.orderBy) {
            if (request.orderBy == "cityName") {
              params.sortBy = "cityData.cityName";
            } else {
              params.sortBy = request.orderBy;
            }
            if (request.ascending == 1) {
              params.sortOrder = "asc";
            } else {
              params.sortOrder = "des";
            }
          }

          if (request.query != "") {
            // if(request.query.length < 3) return;
            params.searchString = request.query.trim();
          }

          this.loading = true;
          return this.$dailyWagesDataRepository.List(params).catch((error) => {
            console.error("dailyWages .requestFunction-error:", error);
          });
        },

        responseAdapter: (response) => {
          this.loading = false;
          var dataDailyWages = [];
          let count;
          response.data.response.forEach((element) => {
            var dailyWagesData = element;
            dailyWagesData["cityName"] =
              element.cityData != null ? element.cityData.cityName : null;

            dailyWagesData["firstName"] =
              element.createdBy != null
                ? element.createdBy.firstName +
                  " " +
                  (element.createdBy.lastName || "")
                : null;
            dataDailyWages.push(dailyWagesData);
          });
          this.user1 = dataDailyWages;
          if (dataDailyWages.length === 0) {
            count = 0;
          }
          return {
            data: dataDailyWages,
            count: response.data.total || count,
          };
        },

        customFilters: [
          {
            name: "custom_filter",
            callback: function(row, query) {},
          },
        ],
        uniqueKey: "_id",
      },
    };
  },
  computed: {
    addButtonClass() {
      if (this.dailyWagesTable) {
        return this.dailyWagesTable.count > this.dailyWagesTable.limit ||
          this.dailyWagesTable.limit > 10
          ? "shift-add-left"
          : "add-item";
      } else {
        return "add-item";
      }
    },
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    endDate() {
      if (this.date.startDate != "" && this.date.endDate != "") {
        const eventData = this.date.endDate.split("-");
        const endDate = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
        this.endDateIso = new Date(endDate).toISOString();
        this.getListByDate();
      } else {
        this.$refs.dailyWagesTable.refresh();
      }
    },
    startDate() {
      const eventData = this.date.startDate.split("-");
      const startDates = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
      this.startDateIso = new Date(startDates).toISOString();

      if (this.date.startDate != "" && this.date.endDate != "") {
        this.getListByDate();
      } else {
        this.$refs.dailyWagesTable.refresh();
      }
    },
    getListByDate() {
      let params = {};
      params.page = this.page;
      params.limit = this.limit;
      params.startDate = this.startDateIso;
      params.endDate = this.endDateIso;
      this.loading = false;
      var dataDailyWages = [];
      return this.$dailyWagesDataRepository
        .List(params)
        .then((response) => {
          this.$refs.dailyWagesTable.data = [];
          response.data.response.forEach((element) => {
            var dailyWagesData = element;
            dailyWagesData["cityName"] =
              element.cityData != null ? element.cityData.cityName : null;
            dailyWagesData["firstName"] =
              element.createdBy != null
                ? element.createdBy.firstName +
                  " " +
                  (element.createdBy.lastName || "")
                : null;
            dataDailyWages.push(dailyWagesData);
          });

          this.$refs.dailyWagesTable.data = dataDailyWages;
          this.$refs.dailyWagesTable.count = dataDailyWages.length;
        })
        .catch((error) => {
          console.error("dailyWages .requestFunction-error:", error);
        });
    },

    fieldClassName: formService.fieldClassName,

    deleteDailyWagesModal(row) {
      swal({
        title: "Are you sure you want to delete?",

        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        customClass: "swal-modal2",
        width: "400px",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.deleteDailyWages(row);
        }
      });
    },

    changestate() {
      this.filterDateData = {};
    },

    deleteDailyWages(row) {
      this.loading = true;

      return dailyWagesService
        .deleteDailyWages(row._id)
        .then((response) => {
          this.loading = false;
          this.$refs.dailyWagesTable.refresh();
          this.$snotify.success(
            `The Daily Wages has been deleted successfully.`
          );
        })
        .then((response) => {
          this.loading = false;
          this.$router.push("/dailywages");
        })
        .catch((error) => {
          this.loading = false;
          this.$snotify.error("Delete Daily Wages failed", "Error!");
        });
    },

    action(row) {
      this.$router.push({
        name: "dailywagescreate",
        params: {
          _id: row._id,
        },
        props: row,
      });
    },

    onLoaded() {
      this.dailyWagesTable = this.$refs.dailyWagesTable;
    },
    clearFilter() {
      this.custom_filter_select = "";
    },
    applyFilter(filter_val) {
      Event.$emit("vue-tables.customFilters::custom_filter", filter_val);
    },
  },
  mounted() {
    eventBus.$on("DATA_PUBLISHED", (payload) => {});
    if (this.$store.state.auth.user.role.key === "superAdmin") {
      this.options.sortable.push("cityName");
    }
    document.addEventListener("click", (event) => {
      if (
        event.target.closest(".close-date-picker") &&
        !event.target.matches(".gradientbt") &&
        !event.target.closest(".datedrop_boxs") &&
        !event.target.closest(".datemodify")
      ) {
        this.show = false;
     
      }
    });
    // fetch("https://jsonplaceholder.typicode.com/users")
    //     .then(resp => resp.json())
    //     .then(json => (this.users = json));
  },
};
</script>

<style>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 200px;
}

.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.gradientbt {
  background: #0f6940;
  color: white;
}

/* new css */

.toggle {
  --width: 64px;
  --height: calc(var(--width) / 3);

  position: relative;
  display: inline-block;
  width: var(--width);
  height: var(--height);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
  border-radius: var(--height);
  cursor: pointer;
  margin-bottom: 0px;
  position: relative;
  top: 2px;
}

.toggle input {
  display: none;
}

.toggle .slider {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: var(--height);
  background-color: #ccc;
  transition: all 0.4s ease-in-out;
}

.toggle .slider::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: calc(var(--height));
  height: calc(var(--height));
  border-radius: calc(var(--height) / 2);
  background-color: #fff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
  transition: all 0.4s ease-in-out;
}

.toggle input:checked + .slider {
  background-color: #0f6940;
}

.toggle input:checked + .slider::before {
  transform: translateX(calc(var(--width) - var(--height)));
}

.toggle .labels {
  position: absolute;
  top: 4px;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 10px;
  font-family: sans-serif;
  transition: all 0.4s ease-in-out;
}

.toggle .labels::after {
  content: attr(data-off);
  position: absolute;
  right: 5px;
  color: #4d4d4d;
  opacity: 1;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
  transition: all 0.4s ease-in-out;
}

.toggle .labels::before {
  content: attr(data-on);
  position: absolute;
  left: 5px;
  color: #ffffff;
  opacity: 0;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.4);
  transition: all 0.4s ease-in-out;
}

.toggle input:checked ~ .labels::after {
  opacity: 0;
}

.toggle input:checked ~ .labels::before {
  opacity: 1;
}

.active_wrp {
  display: flex;
  align-items: center;
}

.active_wrp a {
  flex: 0 0 30%;
  color: #0f6940;
  margin-right: 10px;
}

.datedrop_boxs_wrp {
  float: left;
  margin-right: 5px;
  position: relative;
  display: flex;
  align-items: center;
  background: #0f6940;
  border-radius: 5px;
  color: #fff;
  font-weight: 600;
}

.datedrop_boxs {
  position: absolute;
  top: 35px;
  left: 0;
  width: 260px;
  background: #fff;
  padding: 10px;
  display: flex;
  box-shadow: 0 20px 25px -5px #898b8a, 0 8px 10px -6px rgb(0 0 0 / 10%);
  border: 2px solid #c5f1dd;
  z-index: 1;
}

.datedrop_boxs .mx-calendar {
  width: 270px;
}

.datemodify input {
  width: 80px;
  border: 0;
  background: transparent;
  padding: 7px 3px;
}

.datedrop_boxs_wrp button svg {
  width: 20px;
  margin-right: 5px;
  fill: #fff;
}

.datedrop_boxs_wrp button:hover svg {
  fill: #0f6940;
}

.datedrop_boxs_wrp button:hover {
  color: #0f6940;
}

.datedrop_boxs_wrp button {
  display: flex;
}

.datemodify svg {
  width: 20px;
  margin-right: 5px;
  fill: #fff;
  position: relative;
  top: 5px;
  left: 8px;
}
</style>



// WEBPACK FOOTER //
// dailyWages.vue?658aada2